import { ReactNode } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { paths } from "../types/Defaults";

type FooterProps = {
  children?: ReactNode;
  className?: string;
};

const FooterLinks = () => {
  return (
    <div className="text-center d-md-flex justify-content-end">
      {/* <Link
        className="px-1 px-sm-2 px-md-4 py-2 py-md-0 d-block d-sm-inline text-light text-decoration-none"
        to={paths.disclaimer}
      > */}
      <a
        className="px-1 px-sm-2 px-md-4 py-2 py-md-0 d-block d-sm-inline text-light text-decoration-none"
        href={paths.externalDisclaimer}
      >
        Disclaimer
      </a>
      {/* </Link> */}
      {/* <Link
        className="px-1 px-sm-2 px-md-4 py-2 py-md-0 d-block d-sm-inline text-light text-decoration-none"
        to={paths.privacy}
      > */}
      <a
        className="px-1 px-sm-2 px-md-4 py-2 py-md-0 d-block d-sm-inline text-light text-decoration-none"
        href={paths.externalPrivacy}
      >
        Privacy policy
      </a>
      {/* </Link> */}
      {/* <Link
        className="px-1 px-sm-2 px-md-4 py-2 py-md-0 d-block d-sm-inline text-light text-decoration-none"
        to={paths.termsOfService}
      > */}
      <a
        className="px-1 px-sm-2 px-md-4 py-2 py-md-0 d-block d-sm-inline text-light text-decoration-none"
        href={paths.externalTerms}
      >
        Terms of Service
      </a>
      {/* </Link> */}
    </div>
  );
};

export const Footer = ({ children, className }: FooterProps) => {
  return (
    <footer
      className={`footer-page d-flex align-items-center ${className ?? ""}`}
    >
      <Container fluid>
        <Row>
          <Col sm={4} className="py-2 py-sm-0 text-center text-md-start">
            &copy; {new Date().getFullYear()} Systematic Gains
          </Col>
          {children ? (
            <>
              <Col sm={4}>{children}</Col>
              <Col sm={4}>
                <FooterLinks />
              </Col>
            </>
          ) : (
            <Col sm={8}>
              <FooterLinks />
            </Col>
          )}
        </Row>
      </Container>
    </footer>
  );
};
